import React from 'react'
import { mainLogo } from '@/assets/images'
import './index.less'

// 页面页脚组件
export function Footer() {
  return (
    <div className='footer-body'>
      <div className='footer-title'>
        <img src={mainLogo} alt='大标题' />
      </div>
    </div>
  )
}
